<template>
  <v-dialog :value="true" persistent :max-width="maxWidth">
    <v-card>
      <div class="dialog-content">
        <h2 class="dialog-content__title">{{ item.title }}</h2>
        <p v-if="item.description">{{ item.description }}</p>
        <div>
          <ul class="list">
            <SpecialHoursItem
              v-for="(day, index) in customDays"
              :key="day.id"
              :hoursRange="hoursRange"
              :day="day"
              @remove-item="removeItem(index)"
              @changedDate="onChangedDate(index, $event)"
              @trigger="checkDays($event, customDays, index)"
              @switch="handleSwitch(index, $event)"
            />
          </ul>
          <ui-button color="secondary" class="mt-6" @click="handleClick">
            {{ $t("message.facilityDetails.addAnotherDay") }}
          </ui-button>
        </div>
      </div>
      <div class="dialog-actions">
        <ui-button
          class="mx-2"
          color="primary"
          outlined
          :width="buttonWidth"
          @click="$emit('close')"
        >
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button
          class="mx-2"
          color="primary"
          :disabled="notValid"
          :width="buttonWidth"
          @click="handleSaveClick(customDays)"
        >
          {{ $t("message.common.save") }}
        </ui-button>
      </div>
      <div class="dialog-footer">
        <v-icon class="mr-2" color="secondary">
          mdi-information-outline
        </v-icon>
        <p class="footer-description">
          {{ $t("message.facilityDetails.footer.openingHours") }}
        </p>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SpecialHoursItem from "@/components/FacilityDetails/Dialog/SpecialHours/Item.vue";
import { generateHours } from "@/helpers/helpers";
import { regex } from "@/config/regex";
import cuid from "cuid";
import moment from "moment";

export default {
  name: "FacilityDetailsSpecialHoursDialog",
  components: {
    SpecialHoursItem
  },
  props: {
    days: {
      type: Array,
      default: () => []
    },
    maxWidth: {
      type: Number,
      default: 500
    },
    item: {
      type: Object,
      default: () => {
        return {
          title: ""
        };
      }
    }
  },
  data() {
    return {
      notValid: false,
      hoursRange: [],
      customDays: JSON.parse(JSON.stringify(this.days)),
      buttonWidth: 170
    };
  },
  created() {
    this.hoursRange = generateHours();
  },
  methods: {
    handleClick() {
      const currentDate = moment();

      this.customDays.push({
        id: cuid(),
        is_closed: false,
        formatted_date: currentDate.format("YYYY-MM-DD"),
        start_date: {
          year: +currentDate.format("YYYY"),
          month: +currentDate.format("MM"),
          day: +currentDate.format("DD")
        },
        value: [["", ""]]
      });
    },

    handleSwitch(index, isOpen) {
      this.customDays[index].is_closed = !isOpen || null;
    },

    removeItem(index) {
      this.customDays.splice(index, 1);
    },

    onChangedDate(index, date) {
      this.customDays[index].formatted_date = moment(date).format("YYYY-MM-DD");
      this.customDays[index].start_date = {
        year: +moment(date).format("YYYY"),
        month: +moment(date).format("MM"),
        day: +moment(date).format("DD")
      };
    },

    validate(item) {
      if (!item) return false;

      const match = item ? item.match(regex.timeFormat) : null;
      if (!(match && !!match[0])) return false;

      return true;
    },

    checkDays(hours, days, index) {
      const day = this.customDays[index];
      day.value = !day.is_closed ? hours : [];
      const valuesArr = days.map(day => day.value).flat();
      const flatten = valuesArr.flat();
      const isNotValid = flatten.some(item => this.validate(item) === false);

      if (isNotValid) {
        this.notValid = true;
        return;
      }
      this.notValid = false;
    },

    handleSaveClick(days) {
      if (!this.notValid) {
        this.$emit("save", days);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  margin-top: $spacing * 5;
  padding: 0;
}

.dialog-content {
  padding: $spacing * 5 $spacing * 7.5;
}

.dialog-content__title {
  @include font-size(16px);
  text-align: center;
  font-weight: $font-weight-semi-bold;
}

.dialog-actions {
  display: flex;
  justify-content: center;
  padding: $spacing * 2.5 0;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  margin: 0 auto;
  padding: $spacing * 4 0;
}

.footer-description {
  @include font-size(14px);
  margin-bottom: 0;
}
</style>
